import Request from '../../services/Requests.js'
import * as types from '../mutation-types'
import _ from 'lodash'

// state
export const state = {
    all: [],
    getSubscriptionById: {}
};

// mutations
export const mutations = {
    [types.ADD_SUBSCRIPTIONS] (state, subscriptions) {
        state.all = subscriptions;
    },

    [types.ADD_SUBSCRIPTION] (state, subscription) {
        let aSubscription = _.head(subscription.data);
        state.all.push(aSubscription);
    },

    [types.UPDATE_SUBSCRIPTION] (state, subscription) {
        let aSub = _.head(subscription.data),
            index = _.findIndex(state.all, function (item) { return item.id === aSub.id });
        state.all[index] = aSub;
    },

    [types.ADD_SUBSCRIPTION_BY_ID] (state, subscription) {
        state.getSubscriptionById = subscription;
    },
};

// actions
export const actions = {
    saveSubscription({commit}, data) {
        commit(types.ADD_SUBSCRIPTION, data);
    },

    updateSubscription({commit}, data) {
        commit(types.UPDATE_SUBSCRIPTION, data);
    },

    /**
     *
     * @param commit
     * @param userId
     * @return {Promise<void>}
     */
    getSubscriptions ({ commit }) {
        if (state.all.length > 0) {
            return new Promise((resolve) => {
                setTimeout(() => resolve('Subscriptions have been retrieving already'), 20);
            })
        }

        return (new Request()).get('/libraries/subscriptions')
            .then(response => {
                if (response.isSuccess()) {
                    const data = response.getData();
                    commit(types.ADD_SUBSCRIPTIONS, data);
                }
            })
    },

    getSubscriptionById({commit}, id) {
        if ((state.all.length > 0) === false) {
            return new Promise((resolve) => {
                setTimeout(() => resolve('Subscriptions have been retrieving already'), 20);
            })
        }

        let data = _.filter(
            state.all,
            function (subscription) {
                return subscription.id === id;
            });
        if (_.isArray(data)) {
            data = _.head(data);
        }
        commit(types.ADD_SUBSCRIPTION_BY_ID, data);
    },
};

// getters
export const getters = {
    /**
     *
     * @param state
     * @return {Array|*}
     */
    getSubscriptions: state => state.all,
    getSubscriptionById: state => state.getSubscriptionById
};


// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/subscriptions.js